import { RailQueryParams } from "./query.types";
import { SearchReferenceDTO } from "entities/shared/shipmentCard.types";
import { Nullable } from "shared/lib/typeCheck.lib";

type CreateRailSearchQueryParamsParams = {
  requestType: "openedCard" | "updateCard" | "search";
  override?: Partial<RailQueryParams>;
};

export const createRailSearchQueryParams = ({
  requestType,
  override,
}: CreateRailSearchQueryParamsParams): RailQueryParams | null => {
  const reference: Nullable<SearchReferenceDTO> = override?.number;
  const scacCode: Nullable<SearchReferenceDTO> = override?.carrier_code;

  if (!reference) return null;

  switch (requestType) {
    case "openedCard":
      return Object.assign({
        number: reference,
        ...(scacCode ? { carrier_code: scacCode } : {}),
      });
    case "search":
    default:
      return Object.assign({ number: reference, ...(scacCode ? { carrier_code: scacCode } : {}) });
  }
};
